var toString = require('../lang/toString');
    /**
     * Remove HTML tags from string.
     */
    function stripHtmlTags(str){
        str = toString(str);

        return str.replace(/<[^>]*>/g, '');
    }
    module.exports = stripHtmlTags;




//////////////////
// WEBPACK FOOTER
// ./~/mout/string/stripHtmlTags.js
// module id = 1679
// module chunks = 0 1 2